<template>
   <div id="error">
        <!-- 非法路径 -->
   </div>
</template>
<script>
    export default {
        name: "error",
        components: {},
        data() {
            return {};
        },
        created() {

        },
        mounted() {},
        methods: {}
    }
</script>

<style lang="scss" scoped>

</style>
